<template>
  <div v-if="videoUrl" class="flex-center relative w-full">
    <iframe
        v-if="videoId && youTubeVideoUrl"
        width="100%"
        :height="height"
        :src="youTubeVideoUrl"
        frameborder="0"
        allowfullscreen
        :style="iframeStyle"
    ></iframe>
  </div>
</template>

<script setup>
const props = defineProps({
  videoUrl: {
    type: String,
    default: ''
  },
  height: {
    type: Number,
    default: 640
  }
})
const videoId = ref('');
const innerWid = ref('');
const height = ref(props?.height || 640);

const extractVideoId = (url) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=))([^"&?\/\s]{11})/);
  return match ? match[1] : '';
};

const youTubeVideoUrl = computed(() => `https://www.youtube.com/embed/${videoId.value}?rel=0`);
const iframeStyle = computed(() => {
  if (!useNuxtApp().$device.isDesktop) {
    return {height: innerWid.value * 0.5625 + 'px !important'}
  } else {
    return {height: height.value + 'px !important'}
  }
})

onMounted(() => {
  innerWid.value = window.innerWidth
  videoId.value = extractVideoId(props.videoUrl);
});

</script>

<style lang="scss" scoped>

</style>